export default __webpack_public_path__ + "static/media/pageNotFound.442095f1.png";